export enum BottomBarFeatures {
    // bottom bar features
    TOGGLE_THUMBNAILS = 'TOGGLE_THUMBNAILS',
    TOGGLE_PANES = 'TOGGLE_PANES',
    CHANGE_LANGUAGE_AND_VOICE = 'CHANGE_LANGUAGE_AND_VOICE',
    GO_FIRST_PAGE = 'GO_FIRST_PAGE',
    GO_PREV_PAGE = 'GO_PREV_PAGE',
    GO_NEXT_PAGE = 'GO_NEXT_PAGE',
    GO_LAST_PAGE = 'GO_LAST_PAGE',
    GO_N_PAGE = 'GO_N_PAGE',
    ZOOM_ADD = 'ZOOM_ADD',
    ZOOM_REMOVE = 'ZOOM_REMOVE',
    ZOOMING = 'ZOOMING',
    CHANGE_VIEW_MODE = 'CHANGE_VIEW_MODE',
    CHANGE_FIT_MODE = 'CHANGE_FIT_MODE',
    ROTATE_CLOCKWISE = 'ROTATE_CLOCKWISE',
    ROTATE_COUNTER_CLOCKWISE = 'ROTATE_COUNTER_CLOCKWISE',
    SPELL_CHECKER_PROCESSING_STATUS = 'SPELL_CHECKER_PROCESSING_STATUS',
    AUDIO_MAKER_SELECTION_COUNTER = 'AUDIO_MAKER_SELECTION_COUNTER',
    TEXT_SETTINGS = 'TEXT_SETTINGS',
}
